'use client'

import Image from 'next/image'
import qr from 'qrcode'
import { useEffect, useState } from 'react'

import { cn } from '@/lib/utils'

interface QRCodeProps {
  secret: string
  size?: number
  className?: string
  imageClassName?: string
}

export default function QRCode({ secret, size = 224, className, imageClassName }: QRCodeProps) {
  const [qrCode, setQRCode] = useState<string | null>(null)

  useEffect(() => {
    const createQRCode = () => {
      qr.toDataURL(secret, (_, dataUrl) => {
        setQRCode(dataUrl)
      })
    }

    createQRCode()
  }, [secret])

  return (
    <div
      className={cn('bg-ox-paper relative overflow-hidden', className)}
      style={{ width: size, height: size }}
    >
      <div className="bg-ox-paper absolute inset-0 size-full animate-pulse" />
      {qrCode && (
        <Image
          src={qrCode}
          alt="QR Code"
          width={size}
          height={size}
          className={cn('relative size-full object-contain', imageClassName)}
        />
      )}
    </div>
  )
}
